module.exports = __webpack_public_path__ + "img/住宿费用明细表示例.0068d9cc.png";